// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
export function isScopeAdmin(name: string) {
  const skippable = ['admin', 'community'];
  return skippable.some(category => {
    return category === name;
  });
}

export function getAdminScope() {
  return ['*'];
}

export function disableMultiSelectRadio(roleName: string, category: string) {
  if (roleName === 'formation-team') {
    return true;
  }
  if (category === 'aggregate') {
    return true;
  } else if (category === 'ui') {
    return true;
  } else if (category === 'project') {
    const roleNames = ['lf-legal', 'lf-finance', 'lf-it-staff'];
    return roleNames.some(name => {
      return name === roleName;
    });
  } else if (category === 'organization') {
    const roleNames = ['lf-legal', 'lf-finance', 'lf-program-manager', 'lf-executive', 'lf-staff'];
    return roleNames.some(name => {
      return name === roleName;
    });
  } else if (category === 'staff') {
    const roleNames = ['lf-staff'];
    return roleNames.some(name => {
      return name === roleName;
    });
  }
  return false;
}

export function disableSelectAllRadio(roleName: string, category: string) {
  if (category === 'project') {
    const roleNames = [
      'community-program-manager',
      'lf-program-manager',
      'company-admin',
      'contact',
      'community-it-operations',
      'meetings-coordinator'
    ];
    return roleNames.some(name => {
      return name === roleName;
    });
  } else if (category === 'organization') {
    const roleNames = ['community-program-manager', 'company-admin', 'contact'];
    return roleNames.some(name => {
      return name === roleName;
    });
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/app/core/utilities/scopes.helpers.ts